import { render, staticRenderFns } from "./ContractsPaidUnpaidChart.vue?vue&type=template&id=b2c1a190&scoped=true"
import script from "./ContractsPaidUnpaidChart.vue?vue&type=script&lang=js"
export * from "./ContractsPaidUnpaidChart.vue?vue&type=script&lang=js"
import style0 from "./ContractsPaidUnpaidChart.vue?vue&type=style&index=0&id=b2c1a190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c1a190",
  null
  
)

export default component.exports